import React from 'react';
import {type Secret} from 'src/generated/graphql';

export type JobDrawerSecretsContextType = {
  secretsData: Secret[];
  secretsLoading: boolean;
  secretsError: boolean;
  refetchSecrets: () => void;
};

export const JobDrawerSecretsContext =
  React.createContext<JobDrawerSecretsContextType>({
    secretsData: [],
    secretsLoading: false,
    secretsError: false,
    refetchSecrets: () => {},
  });
